import styled from 'styled-components'

const SidebarSection = styled.div`
	display: flex;
	flex-direction: column;
`

export default SidebarSection